import { put, takeLeading } from 'redux-saga/effects';
import { sendError } from '../../../';
import { currenciesData, currenciesError, CurrenciesFetch } from '../actions';
import { CURRENCIES_FETCH } from '../constants';

export function* rootCurrenciesSaga() {
    yield takeLeading(CURRENCIES_FETCH, currenciesFetchSaga);
}

export function* currenciesFetchSaga(action: CurrenciesFetch) {
    try {
        // const currencies = yield call(API.get(currenciesOptions), '/public/currencies');
        const currencies = {
            list: [],
            loading: false,
        };
        yield put(currenciesData(currencies as any));
    } catch (error) {
        yield put(
            sendError({
                error,
                processingType: 'alert',
                extraOptions: {
                    actionError: currenciesError,
                },
            }),
        );
    }
}
